/**
 * Shared enrollment microcopy.
 *
 * The enrollment wall (EnrollmentWall) and first-run onboarding
 * (OnboardingFlow) explain the same thing on two different screens, and had
 * drifted into two near-identical wordings that then had to be corrected
 * twice. They live here so a copy change lands on both at once.
 *
 * Voice rules these have to keep satisfying (steward-site CLAUDE.md):
 *   - no em/en dashes;
 *   - no absolutes we can't stand behind. A second factor does not "prove it's
 *     you" and does not mean you are "never locked out"; it protects access,
 *     and it means one exposed credential is not enough on its own;
 *   - "credential", not "password". Google and passkey users never set one, so
 *     the old "even if a password is guessed" framing was simply wrong for
 *     them.
 */

/** Body under "Let's protect your account" on the hard wall. */
export const ENROLLMENT_WALL_BODY =
  'Before you come in, add a second check at sign-in. It protects what you ' +
  'have entrusted to Steward, even if one credential is ever exposed.';

/** Body on step 1 of first-run onboarding, where nothing exists yet. */
export const ONBOARDING_ENROLL_BODY =
  'The first step is a sign-in key, a second check when you sign in. It ' +
  'protects your information even if a credential is ever exposed.';

/** Shown when the browser/device can't do WebAuthn at all. */
export const NO_PASSKEY_SUPPORT =
  'This device doesn’t support a passkey, so we’ll set up an authenticator app instead.';

/** Hint under the "Add your passkey" button. */
export const PASSKEY_HINT = 'Use Face ID, Touch ID, Windows Hello, or a security key.';

/** Heading + body for the "add a backup factor" step after a passkey lands. */
export const BACKUP_PROMPT_LABEL = 'Recommended: add a backup';
export const BACKUP_PROMPT_BODY =
  'An authenticator app code works even if you lose the device your passkey ' +
  'lives on. It takes a minute, and you can always add it later from Settings.';

/**
 * Declining the backup. Never "skip" (the gap is real and stays visible in
 * Settings), and never "Continue to Steward" — on the onboarding path the user
 * is not entering Steward yet, and carrying one label across both screens is
 * what keeps them from diverging again. Asserted in OnboardingFlow.test.tsx
 * and EnrollmentWall.test.tsx.
 */
export const BACKUP_DECLINE = 'Continue without a backup';
